import React from 'react'
import PropTypes from 'prop-types'
import { getIn } from 'formik'
import InputTagRaw from '~/components/common/InputTag'

const InputTag = ({ form, field, error, helperText, disabled, ...props }) => (
  <InputTagRaw
    name={field.name}
    error={
      !!error ||
      (!!getIn(form.touched, field.name) && !!getIn(form.errors, field.name))
    }
    helperText={
      helperText ||
      (getIn(form.touched, field.name) && getIn(form.errors, field.name))
    }
    tags={field.value}
    {...field}
    onTagsChange={(newTags) => {
      form.setFieldValue(field.name, newTags)
    }}
    disabled={disabled || !!form.values.__readOnly}
    {...props}
  />
)

InputTag.defaultProps = {
  error: '',
  helperText: '',
  disabled: false,
}

InputTag.propTypes = {
  form: PropTypes.shape().isRequired,
  error: PropTypes.string,
  helperText: PropTypes.string,
  field: PropTypes.shape().isRequired,
  disabled: PropTypes.bool,
}

export default InputTag
